import React from 'react';

export default class Spinner extends React.Component {
	render() {
        return (
            <div className="loading-overlay" style={{ backgroundColor: "#FFF", borderRadius: 0 }}>
                <div className="bounce-loader">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                </div>
            </div>
        )
	}
}
